import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Menu, X } from 'lucide-react';
import { businessInfo } from '../mockData';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'Services', href: '/services' },
    { name: 'Reviews', href: '/reviews' },
    { name: 'About', href: '/about' },
    { name: 'Contact', href: '/contact' }
  ];

  return (
    <header className="dark-header">
      <div className="dark-logo-container">
        <Link to="/" className="dark-logo-text">
          {businessInfo.name}
        </Link>
      </div>

      {/* Desktop Navigation */}
      <nav className="dark-nav">
        {navigation.map((item) => (
          <Link
            key={item.name}
            to={item.href}
            className={`dark-nav-link ${
              location.pathname === item.href ? 'active' : ''
            }`}
          >
            {item.name}
          </Link>
        ))}
        <a href={`tel:${businessInfo.phone}`} className="btn-primary">
          <Phone size={20} />
          {businessInfo.phone}
        </a>
      </nav>

      {/* Mobile Menu Button */}
      <button
        className="mobile-menu-btn"
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
      >
        {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div className="mobile-menu">
          {navigation.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              className={`mobile-nav-link ${
                location.pathname === item.href ? 'active' : ''
              }`}
              onClick={() => setMobileMenuOpen(false)}
            >
              {item.name}
            </Link>
          ))}
          <a
            href={`tel:${businessInfo.phone}`}
            className="btn-primary mobile-call-btn"
          >
            <Phone size={20} />
            {businessInfo.phone}
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;